var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAgriculture(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500.2 500.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#018b9d;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Coloured_icons",
    "data-name": "Coloured icons"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M426.94,73.22c-97.62-97.63-256-97.63-353.68,0s-97.63,256,0,353.72,256,97.63,353.68,0,97.63-256,0-353.72Zm-11,342.72c-91.62,91.62-240.06,91.62-331.68,0s-91.62-240.08,0-331.71C176.48-6.7,324.92-5.7,415.84,86.53c90,91.33,90,238,0,329.31h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M420,112.24a7.88,7.88,0,0,0-13.2,8.6,6.89,6.89,0,0,0,1.1,1.3c70.82,87,57.61,215.07-29.41,285.89a203,203,0,0,1-264-6.5,7.86,7.86,0,0,0-11.51,10.7,8.12,8.12,0,0,0,1,.9c89.73,80.93,228.06,73.73,309-16,72.22-80.33,75.22-201.27,7-284.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M46.85,250C46.85,137.74,137.77,46.82,250,46.82A203,203,0,0,1,385.43,98.53a7.9,7.9,0,0,0,10.51-11.7C305.71,6.4,167.38,14.3,87,104.53a218.88,218.88,0,0,0-7,283.1,7.79,7.79,0,0,0,11.1-.1,7.87,7.87,0,0,0,1-9.81A203.19,203.19,0,0,1,46.85,250Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M362.93,115.44v-.5a5.43,5.43,0,0,0-5.9-4.7c-1.7.2-4.9,5.2-6,6.5a72,72,0,0,1-6.61,7.9,59.38,59.38,0,0,1-18.3,10.8c-13.7,5.81-29,7.91-43.61,10.11-7.9,1.2-15.71,2.5-23.31,4.3-34,8.5-49.91,31.61-46.31,66.52.7,6.2,10.5,6.3,9.8,0-1.9-18.51,0-36.81,16.61-48,12.8-8.6,29.7-11,44.51-13.6,24.7-4.3,52.41-8.2,70.32-26.21,2,28.21.4,57.62-12.91,82.83-20.7,38.81-71.11,38.11-106.12,21a249.44,249.44,0,0,1,41.21-37.72c5-3.7,0-12.3-4.9-8.5C237,211.67,207,241.88,196.49,284.79c-1.5,6.2,7.9,8.81,9.5,2.6a129.89,129.89,0,0,1,22.8-47.51c36.81,18.9,86.93,20.8,114.63-14.31,23.61-29.81,23.21-74,19.41-110v-.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M243.6,369.82H216.49a6.76,6.76,0,0,0-.8,13.5H243.6a6.76,6.76,0,0,0,.8-13.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M256.9,349.61H203a6.77,6.77,0,0,0-.8,13.51H256.9a6.77,6.77,0,0,0,0-13.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M184.08,199.46a66.14,66.14,0,0,1,23-14.5,72.58,72.58,0,0,1,5.2-15.71,79.66,79.66,0,0,0-59.71,95.54,78.58,78.58,0,0,0,18.5,35.41,6.77,6.77,0,0,0,11.2-7.6,4.94,4.94,0,0,0-1.4-1.51A65.77,65.77,0,0,1,184.08,199.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M294.71,260.28A66,66,0,0,1,279,291.19a6.79,6.79,0,0,0,9.4,9.81c.2-.2.4-.5.6-.7a79.84,79.84,0,0,0,19.8-41.92A73.62,73.62,0,0,1,294.71,260.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M270.51,309h-81a6.76,6.76,0,0,0-.8,13.5h81.83a6.68,6.68,0,0,0,6.3-7.2A6.86,6.86,0,0,0,270.51,309Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M270.51,329.31h-81a6.76,6.76,0,0,0,0,13.5h81a6.68,6.68,0,0,0,6.3-7.2A6.86,6.86,0,0,0,270.51,329.31Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgriculture);
export default __webpack_public_path__ + "static/media/Agriculture.6b38e26da8da5d1a4c1a8f774be67894.svg";
export { ForwardRef as ReactComponent };